import { EventCategory } from '@/utils/types'

const ctas: Record<EventCategory, string> = {
  [EventCategory.Conference]: 'Schedule',
  [EventCategory.Meetup]: 'RSVP'
}

export const eventCta = (category: EventCategory) => ctas[category]

const labels: Record<EventCategory, string> = {
  [EventCategory.Conference]: 'Conference',
  [EventCategory.Meetup]: 'Meetup'
}

export const eventLabel = (category: EventCategory) => labels[category]
